module.exports = __webpack_public_path__ + "img/domain_var.c077da68.png";